"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = void 0;
var overlayHtml = "\n<div class=\"vmap__overlay\">\n    <div class=\"vmap__overlay__inner\">\n        <div class=\"vmap__overlay__content\"><span class=\"vmap__spinner\"></span></div>\n    </div>\n</div>";
var overlayCss = "\n.vmap__overlay {\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background: #bbb;\n}\n\n.vmap__overlay__inner {\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n}\n\n.vmap__overlay__content {\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.vmap__spinner {\n    width: 75px;\n    height: 75px;\n    display: inline-block;\n    border-width: 2px;\n    border-color: rgba(255, 255, 255, 0.05);\n    border-top-color: #fff;\n    animation: spin 1s infinite linear;\n    border-radius: 100%;\n    border-style: solid;\n}\n\n@keyframes spin {\n    100% {\n        transform: rotate(360deg);\n    }\n}";
var Overlay = (function () {
    function Overlay(element) {
        this._elt = element;
        this._elt.style.position = 'relative';
        this.doc = this._elt.ownerDocument;
        this.head = this.doc.head || this.doc.getElementsByTagName('head')[0];
        this.style = this.doc.createElement('style');
        this.head.appendChild(this.style);
        this.style.innerText = overlayCss;
        this._elt.innerHTML = overlayHtml;
        this.overlay = element.querySelector('.vmap__overlay');
    }
    Overlay.prototype.show = function () {
        this.overlay.style.display = 'block';
    };
    Overlay.prototype.hide = function () {
        this.overlay.style.display = 'none';
    };
    Overlay.prototype.destroy = function () {
        this.style.remove();
        this.overlay.remove();
    };
    return Overlay;
}());
exports.Overlay = Overlay;
//# sourceMappingURL=overlay.js.map